import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getItemDetailAgentId } from '@/redux/modules/itemDetail';
import { useAppSelector } from '@/redux/hooks';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styled from 'styled-components';

export type ShopAllFromSellerLinkProps = {
    itemId: number;
};

const ShopAllFromSellerLink = ({ itemId }: ShopAllFromSellerLinkProps) => {
    const agentId = useAppSelector((state) => getItemDetailAgentId(state, itemId));

    return (
        <StyledSellerAction>
            <StyledLink
                rel="noopener"
                route
                target="_blank"
                to={`/seller/${agentId}/`}
            >
                <FormattedMessage id="itemPage.shippingOptions.shopMoreFromSeller" />
            </StyledLink>
        </StyledSellerAction>
    );
};

export default ShopAllFromSellerLink;

const StyledLink = styled(Link)`
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

const StyledSellerAction = styled(BodySecondary)`
    margin-top: 16px;
`;
